var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStartClass(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "89px",
    height: "75px",
    viewBox: "0 0 89 75",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "account-check-outline (1)") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Wise-Proctor",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "2.-Wise-Proctor-Instructor-Main",
    transform: "translate(-1490.000000, -1459.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(611.000000, 1355.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "account-check-outline-(1)",
    transform: "translate(879.000000, 104.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.6102564,38.6363636 L89,45.0454545 L59.1964103,75 L43.3589744,59.0909091 L49.7487179,52.6818182 L59.1964103,62.1363636 L82.6102564,38.6363636 M36.5128205,0 C46.5955575,0 54.7692308,8.14027728 54.7692308,18.1818182 C54.7692308,28.2233591 46.5955575,36.3636364 36.5128205,36.3636364 C26.4300835,36.3636364 18.2564103,28.2233591 18.2564103,18.1818182 C18.2564103,8.14027728 26.4300835,0 36.5128205,0 M36.5128205,9.09090909 C31.471452,9.09090909 27.3846154,13.1610477 27.3846154,18.1818182 C27.3846154,23.2025886 31.471452,27.2727273 36.5128205,27.2727273 C41.554189,27.2727273 45.6410256,23.2025886 45.6410256,18.1818182 C45.6410256,13.1610477 41.554189,9.09090909 36.5128205,9.09090909 M36.5128205,40.9090909 C39.6164103,40.9090909 43.3589744,41.3181818 47.5123077,42.0909091 L39.8902564,49.6818182 L36.5128205,49.5454545 C22.9574359,49.5454545 8.67179487,56.1818182 8.67179487,59.0909091 L8.67179487,64.0909091 L36.9692308,64.0909091 L45.6410256,72.7272727 L0,72.7272727 L0,59.0909091 C0,47 24.3266667,40.9090909 36.5128205,40.9090909 Z",
    id: "Shape"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartClass);
export default __webpack_public_path__ + "static/media/start-class.c0f428bf800563e89d9ad2ba05cbb3fe.svg";
export { ForwardRef as ReactComponent };